import 'css-chunksrc/client/scenes/project/projectStatus/statusList/styles.scss';export default {
  "statusList": "_statusList_1akt2_1",
  "status": "_status_1akt2_1",
  "topElement": "_topElement_1akt2_19",
  "folder": "_folder_1akt2_27",
  "folderIcon": "_folderIcon_1akt2_32",
  "name": "_name_1akt2_41",
  "description": "_description_1akt2_50",
  "icon": "_icon_1akt2_54"
};